/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Already_HaveInputs */

const en_plan_already_have = /** @type {(inputs: Plan_Already_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already have this plan`)
};

const es_plan_already_have = /** @type {(inputs: Plan_Already_HaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya tienes este plan`)
};

/**
* | output |
* | --- |
* | "You already have this plan" |
*
* @param {Plan_Already_HaveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_already_have = /** @type {((inputs?: Plan_Already_HaveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Already_HaveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_already_have(inputs)
	return en_plan_already_have(inputs)
});